// Demo mode configuration for when backend is not available
export const DEMO_MODE = false; // Set to true to enable demo mode, false to use real backend

// Demo admin credentials
export const DEMO_ADMIN = {
  username: 'admin',
  password: 'admin123',
  token: 'demo-jwt-token-12345'
};

// Demo data
export const DEMO_DATA = {
  blogs: [
    {
      id: 1,
      title: 'Getting Started with React Development',
      slug: 'getting-started-react-development',
      excerpt: 'Learn the fundamentals of React development...',
      content: 'This is demo content for React development blog post.',
      category: 'Web Development',
      author: 'Admin',
      createdAt: '2025-10-20T10:00:00Z',
      views: 150,
      likes: 12,
      comments: 5
    },
    {
      id: 2,
      title: 'Mobile App Development Best Practices',
      slug: 'mobile-app-development-best-practices',
      excerpt: 'Discover the best practices for mobile app development...',
      content: 'This is demo content for mobile app development blog post.',
      category: 'Mobile Development',
      author: 'Admin',
      createdAt: '2025-10-19T10:00:00Z',
      views: 89,
      likes: 8,
      comments: 3
    }
  ],
  
  portfolio: [
    {
      id: 1,
      title: 'E-commerce Web Application',
      slug: 'ecommerce-web-application',
      category: 'web',
      description: 'Full-stack e-commerce solution with React and Node.js',
      image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=600',
      technologies: ['React', 'Node.js', 'MongoDB', 'Stripe'],
      featured: true,
      status: 'published'
    },
    {
      id: 2,
      title: 'Mobile Banking App',
      slug: 'mobile-banking-app',
      category: 'mobile',
      description: 'Secure mobile banking application with biometric authentication',
      image: 'https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=600',
      technologies: ['React Native', 'Firebase', 'Biometric API'],
      featured: true,
      status: 'published'
    }
  ],
  
  reviews: [
    {
      id: 1,
      name: 'John Smith',
      company: 'Tech Startup Inc.',
      position: 'CEO',
      rating: 5,
      review: 'Outstanding work! The team delivered exactly what we needed.',
      image: null,
      approved: true,
      createdAt: '2025-10-18T10:00:00Z'
    },
    {
      id: 2,
      name: 'Sarah Johnson',
      company: 'Digital Solutions LLC',
      position: 'CTO',
      rating: 5,
      review: 'Professional service and excellent results. Highly recommended!',
      image: null,
      approved: true,
      createdAt: '2025-10-17T10:00:00Z'
    }
  ],
  
  analytics: {
    totalViews: 1250,
    totalLikes: 89,
    totalComments: 45,
    totalReviews: 12
  }
};

// Demo API simulation
export const demoApi = {
  login: async (credentials: any) => {
    await new Promise(resolve => setTimeout(resolve, 1000)); // Simulate network delay
    
    if (credentials.username === DEMO_ADMIN.username && 
        credentials.password === DEMO_ADMIN.password) {
      return {
        success: true,
        token: DEMO_ADMIN.token,
        user: { username: DEMO_ADMIN.username, role: 'admin' }
      };
    }
    
    throw new Error('Invalid credentials');
  },
  
  getBlogs: async () => {
    await new Promise(resolve => setTimeout(resolve, 500));
    return DEMO_DATA.blogs;
  },
  
  getPortfolio: async () => {
    await new Promise(resolve => setTimeout(resolve, 500));
    return DEMO_DATA.portfolio;
  },
  
  getReviews: async () => {
    await new Promise(resolve => setTimeout(resolve, 500));
    return DEMO_DATA.reviews;
  },
  
  getAnalytics: async () => {
    await new Promise(resolve => setTimeout(resolve, 500));
    return DEMO_DATA.analytics;
  }
};